<template>
  <div class="node-quiz-multiple">
    <p v-if="!isArray(question.question)" class="question-text font-heavy text-size-40" v-html="question.question"></p>
    <div v-else>
      <p
        v-for="(line, index) in question.question"
        :key="index"
        :class="[ 'question-text', 'font-heavy', 'text-size-40', line.classes ]"
        v-html="line.text"
      ></p>
    </div>
    <div :class="[ 'flex', { 'pt-4': question.graphic } ]">
      <div
        v-if="question.graphic"
        class="question-graphic"
      >
        <img :src="question.graphic.source" :alt="question.graphic.alt">
      </div>
      <ul :class="[ { 'pt-6': question.graphic } ]">
        <li
          v-for="(answer, index) in question.answers"
          :key="index"
          :id="`answer-${index}`"
        >
          <div :class="[
            'checkbox',
            { selected: selection.indexOf(index) > -1 },
            { review },
            { incorrect: review && !modified &&selection.indexOf(index) > -1 && question.correct.indexOf(index) < 0 } ]" @click.prevent="select(index)"></div>
          <span class="answer-index" v-html="getAnswerIndex(index)"></span>
          <span class="answer-text" :class="[ { 'font-heavy': $store.getters.debug && question.correct.indexOf(index) > -1 } ]" v-html="answer"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NodeQuizMultiple',
  props: {
    question: {
      type: Object,
      required: true,
    },
    progress: {
      type: Number,
      required: true,
    },
    review: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selection: [],
      modified: false,
      count: 99,
    }
  },
  methods: {
    getAnswerIndex(index) {
      return [ 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k' ][index] + ') ';
    },
    select(answer) {
      this.modified = true;
      const index = this.selection.indexOf(answer);
      if (index > -1) {
        this.selection.splice(index, 1);
      } else if (this.selection.length < this.count) {
        this.selection.push(answer);
        this.selection = this.selection.sort();
      }
      this.submit();
    },
    submit() {
      const correct = this.selection.toString() ===  this.question.correct.toString();
      this.$emit('action', { type: 'submit-answer', data: {
        question: this.question.index,
        answers: this.selection,
        correct,
        score: correct ? 1 : 0,
      } });
    },
    isArray(item) {
      return Array.isArray(item);
    }
  },
  mounted() {
    this.count = this.question.count || 99;
    if (this.review) {
      const progress = this.$store.getters.progress[this.progress];
      this.selection = progress.answers[this.question.index];
      if (this.selection === undefined) {
        this.selection = [];
      }
    } else {
      this.submit();
    }
  },
}
</script>